import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5 2.66a1 1 0 0 0 -1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0 -1 -1","key":"svg-0"}]]

/**
 * IconClockHour12Filled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItY2xvY2staG91ci0xMiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTcgMy4zNGExMCAxMCAwIDEgMSAtMTUgOC42NmwuMDA1IC0uMzI0YTEwIDEwIDAgMCAxIDE0Ljk5NSAtOC4zMzZtLTUgMi42NmExIDEgMCAwIDAgLTEgMXY1YTEgMSAwIDAgMCAyIDB2LTVhMSAxIDAgMCAwIC0xIC0xIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/clock-hour-12-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconClockHour12Filled = createReactComponent('filled', 'clock-hour-12-filled', 'ClockHour12Filled', __iconNode);

export default IconClockHour12Filled;